import React from "react";

const FolderTabs = ({ tabs, activeId, onChange, children }) => (
  <div>
    <div className="-mb-px flex items-end gap-1 overflow-x-auto px-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            title={tab.label}
            className={`folder-tab relative shrink-0 px-5 text-xs font-semibold transition ${
              active
                ? "z-10 bg-theme-secondary py-2.5 text-theme-text"
                : "bg-theme-shadow py-2 text-theme-text opacity-55 hover:opacity-80"
            }`}
          >
            <span className="relative z-[1] block max-w-[10rem] truncate">{tab.label}</span>
          </button>
        );
      })}
    </div>
    <div className="rounded-b-xl rounded-tr-xl border border-theme-shadow bg-theme-secondary p-4 sm:p-5">
      {children}
    </div>
  </div>
);

export default FolderTabs;
